'use client';

import { toValidMxpPath } from '@modules/prism/lib/mxp365/paths';
import { useEffect, useRef } from 'react';

import { createMxp365OpenEvent } from './events';
import { createMxp365V2OpenEvent } from './v2/events-v2';
import { pathToModuleV2 } from './v2/path-to-module-v2';

import type { Locale } from '@tuic/i18n';

type Props = {
  mxpToken: string | undefined;
  locale: Locale;
};

export const Mxp365DeeplinkHandler = ({ mxpToken, locale }: Props) => {
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current || !mxpToken) return;

    const searchParams = new URLSearchParams(window.location.search);
    const mxpParam = searchParams.get('mxp');
    if (!mxpParam) return;

    handled.current = true;

    // Clean ?mxp= from URL
    searchParams.delete('mxp');
    const newQueryString = searchParams.toString();
    const url = newQueryString
      ? `${window.location.pathname}?${newQueryString}`
      : window.location.pathname;
    window.history.replaceState({}, document.title, url);

    const path = toValidMxpPath(mxpParam);
    const queryParams = {
      culture: locale === 'de' ? 'de-DE' : 'en-US',
      purchaseLocation: 'WEB',
    };

    const moduleV2 = pathToModuleV2(path);
    if (moduleV2) {
      window.dispatchEvent(
        createMxp365V2OpenEvent({
          module: moduleV2,
          title: 'MXP365',
          token: mxpToken,
          queryParams,
        }),
      );
    } else {
      window.dispatchEvent(
        createMxp365OpenEvent({
          path,
          title: 'MXP365',
          token: mxpToken,
          queryParams,
        }),
      );
    }
  }, [mxpToken, locale]);

  return null;
};
